import crmBaseClient from 'crm/apiClient';

export const getCrmClientsAnalytics = search => crmBaseClient.get(`/crm/analytics/clients/`, { params: { ...search } });

export const getCrmManagersAnalytics = search =>
  crmBaseClient.get(`/crm/analytics/managers/`, { params: { ...search } });

export const getCrmManagers = search => crmBaseClient.get(`/crm/contacts/list/`, { params: { ...search } });

export const getCRMAnalytics = date => crmBaseClient.get(`/crm/analytics/summary/${date}/`);
